<template>
  <router-view />
</template>

<script>
export default {
  name: 'ConfiguracoesMain',
}
</script>
